import {RadioButton} from "primereact/radiobutton";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {OrderList} from "primereact/orderlist";
import React, {useEffect, useState} from "react";
import {SongService} from "../services/SongService";
import {Button} from "primereact/button";
import {durationFromMs} from "../utils/PlaylistHelper";

export function PlaylistDualView({playlist, setPlaylist}) {
    const [playlistView, setPlaylistView] = useState("desktop");
    const [selectedPlaylistRow, setSelectedPlaylistRow] = useState(null);
    const [showDurationCol, setShowDurationCol] = useState(false);

    const rowClass = (data) => {
        let bgcol = false;
        if (selectedPlaylistRow != null) {
            bgcol = (data.isrc === selectedPlaylistRow.isrc);
        }
        return {
            'bg-primary': bgcol
        };
    };

    const imageTemplate = (item) => {
        return (
            <div><img src={item.image_url} width="24"/></div>
        );
    }
    const showDurationColumn = ()=>{
        if(showDurationCol){
            return(<Column key={"duration_ms"} field="duration_ms" header={"Duration"} body={durationTemplate} />)
        }
    }

    const durationTemplate = (item) => {
        return(
            <div> {durationFromMs(item.duration_ms)}</div>
        )
    }


    const itemTemplateOrderList = (item) => {
        let clName ="flex flex-wrap gap-3 mt-2"
        // this does not style the list element (li) but just the div... it does not look good
        // also I did not find out how to set the selected row item yet : TBD later
        // if(selectedPlaylistRow !== null && item.isrc === selectedPlaylistRow.isrc){
        //     clName = "flex flex-wrap gap-3 mt-2 bg-highlight"
        // }
        return (
            <div className={clName}>
                <div>{item.plelementid}</div>
                <div><img src={`${item.image_url}`} width="16" height="16"/></div>
                <div> {item.nameconcat}</div>
            </div>
        );
    }

    return(
        <div>
            <div className="flex flex-wrap gap-3 pt-2">
                <div className="flex align-items-center">
                    <RadioButton inputId="plview1" name="playlistView" value="desktop" onChange={(e) => setPlaylistView(e.value)} checked={playlistView === 'desktop'} />
                    <label htmlFor="plview1" className="ml-2">View 1 (highlight sel. song)</label>
                </div>
                <div className="flex align-items-center">
                    <RadioButton inputId="plview2" name="playlistView" value="mobile" onChange={(e) => setPlaylistView(e.value)} checked={playlistView === 'mobile'} />
                    <label htmlFor="plview2" className="ml-2">View 2 (reorder possible for mobile)</label>
                </div>
            </div>

            <div className="card-controls" hidden={playlist.length === 0 || playlistView !== "desktop"}>
                <div>
                    <DataTable value={playlist}
                               selectionMode="single" selection={selectedPlaylistRow} onSelectionChange={(e) => setSelectedPlaylistRow(e.value)}
                               rowClassName={(data, options) => {if(selectedPlaylistRow !== null && data.isrc === selectedPlaylistRow.isrc){return("bg-highlight")}else{return("")}}}
                               reorderableRows
                               onRowReorder={(e) => setPlaylist(e.value)}>
                        <Column rowReorder style={{width: '1em'}} />
                        <Column header="Pos" headerTooltip="Playlist position" headerStyle={{ width: '1em' }} body={(data, options) => options.rowIndex + 1}></Column>
                        <Column field="image_url" body={imageTemplate} header={<span>
                                <Button style={{padding: 0, margin:0}} icon="pi pi-clock" text onClick={(e) => setShowDurationCol(!showDurationCol)} /> </span>
                        } ></Column>
                        {showDurationColumn()}
                        <Column field="nameconcat" header="Artist - Song"></Column>
                    </DataTable>
                </div>
            </div>

            <div className="card-controls" hidden={playlist.length === 0 || playlistView !== "mobile"}>
                <div>
                    <OrderList value={playlist}
                               listStyle={{height:'auto'}}
                               dataKey="plelementid"
                               itemTemplate={itemTemplateOrderList}
                               onChange={(e) => setPlaylist(e.value)} >
                    </OrderList>
                </div>
            </div>
        </div>
        )
}